<template>
  <ButtonTooltip
    color="primary"
    small
    :text="!bookmarkStore.isBookmarksDisplayed"
    :icon-name="`${
      bookmarkStore.isBookmarksDisplayed ? 'fa-list' : 'fa-list-alt'
    }`"
    :tooltip-text="
      bookmarkStore.isBookmarksDisplayed ? 'Hide Bookmarks' : 'Show Bookmarks'
    "
    :tooltip-props="{ 'nudge-bottom': 8 }"
    button-text-right="Bookmarks"
    @click="
      () =>
        (bookmarkStore.isBookmarksDisplayed =
          !bookmarkStore.isBookmarksDisplayed)
    "
  />
</template>

<script lang="ts">
import Vue from "vue"
import { mapStores } from "pinia"
import { useBookmarksStore } from "@/stores/bookmarks"
import ButtonTooltip from "@evercam/shared/components/ButtonTooltip"

export default Vue.extend({
  name: "ToggleBookmarkDisplay",
  components: { ButtonTooltip },
  computed: {
    ...mapStores(useBookmarksStore),
  },
})
</script>
